import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import Payment from 'src/smoothr-web-app-core/models/Payment';
import Venue from 'src/smoothr-web-app-core/models/Venue';
import { environment } from '../../../environments/environment';
import { Api } from 'src/smoothr-web-app-core/api/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-eservice-apple-pay',
	templateUrl: './eservice-apple-pay.component.html',
	styleUrls: ['./eservice-apple-pay.component.scss'],
})
export class EserviceApplePayComponent implements OnInit {
	@Input() payment: Payment;
	@Input() venue: Venue;
	@Output() paymentSuccess = new EventEmitter<Payment>();
	@Output() paymentError = new EventEmitter<string>();

	statusMessage = '';
	isSubmitting = false;
	showApplePay = false;

	constructor(
		private cdr: ChangeDetectorRef,
		private translate: TranslateService
	) {}

	ngOnInit() {
		if (typeof (window as any).ApplePaySession !== 'undefined' && (window as any).ApplePaySession.canMakePayments()) {
			this.showApplePay = true;
		} else {
			this.statusMessage = this.translate.instant('eservice_apay.status.not_available');
		}
		this.cdr.detectChanges();
	}

	async startApplePay() {
		const rawSum = (this.payment.sum as any)?.$numberDecimal ?? this.payment.sum;
		const amount = Number(rawSum).toFixed(2);
		const currencyCode = this.venue?.currency || 'EUR';
		const countryCode = (this.venue?.country || 'DE').toUpperCase();

		const paymentRequest = {
			countryCode,
			currencyCode,
			supportedNetworks: ['visa', 'masterCard'],
			merchantCapabilities: ['supports3DS'],
			total: {
				label: this.venue?.name || 'Dean & David',
				amount,
			},
		};

		const ApplePay = (window as any).ApplePaySession;
		const session = new ApplePay(3, paymentRequest);

		session.onvalidatemerchant = async (event: any) => {
			try {
				const merchantSession = await Api.getApplePaySession(event.validationURL, this.venue._id, environment.customerGroup);
				session.completeMerchantValidation(merchantSession);
			} catch (e) {
				console.error('[APay] merchant validation failed', e);
				session.abort();
				this.statusMessage = this.translate.instant('eservice_apay.status.init_error');
				this.cdr.detectChanges();
			}
		};

		session.onpaymentauthorized = async (event: any) => {
			this.isSubmitting = true;
			this.statusMessage = this.translate.instant('eservice_apay.status.charging');
			this.cdr.detectChanges();
			try {
				const paymentToken = JSON.stringify(event.payment.token);
				const result = await Api.eServicePay(this.payment._id, paymentToken, undefined, {
					provider: 'APPLE_PAY',
					accountName: this.payment.eServicePayment?.accountName,
				});
				session.completePayment(ApplePay.STATUS_SUCCESS);
				this.paymentSuccess.emit({ ...this.payment, ...result });
			} catch (e: any) {
				session.completePayment(ApplePay.STATUS_FAILURE);
				const msg = e?.message || this.translate.instant('eservice_apay.status.charge_failed');
				this.statusMessage = msg;
				this.paymentError.emit(msg);
			} finally {
				this.isSubmitting = false;
				this.cdr.detectChanges();
			}
		};

		session.oncancel = () => {
			this.statusMessage = '';
			this.cdr.detectChanges();
		};

		session.begin();
	}
}
